import './conversion-quiz.style.sass';
import template from './conversion-quiz.tpl.pug';
import analyticsService from 'common/analytics';

class ConversionQuizController {
    /* @ngInject */
    constructor($state, $transitions, $window) {
        this.$state = $state;
        this.$transitions = $transitions;
        this.$window = $window;
        
        // Define all steps for progress tracking
        this.steps = [
            { name: 'welcome', title: 'Welcome' },
            { name: 'struggles', title: 'Your Challenges' },
            { name: 'tracking', title: 'Current Method' },
            { name: 'goal', title: 'Your Goals' },
            { name: 'suggestion', title: 'Solution' },
            // Temporarily disabled plans step
            // { name: 'plans', title: 'Choose Plan' },
            { name: 'register', title: 'Sign Up' },
            { name: 'download', title: 'Get Started' }
        ];

        // Store answers as user progresses
        this.answers = {};
    }

    $onInit() {
        // If no state is selected, go to welcome
        if (this.$state.current.name === 'conversion-quiz') {
            this.$state.go('conversion-quiz.welcome');
        }

        // Track current step for progress indicator
        this.$transitions.onSuccess({}, (transition) => {
            const toState = transition.to();
            this.currentStep = this.steps.findIndex(
                (step) => toState.name === `conversion-quiz.${step.name}`
            );
            
            // Track page view
            const currentStep = this.steps[this.currentStep];
            if (currentStep) {
                analyticsService.trackPageView(`/start/${currentStep.name}`);
            }
        });

        // Scroll to top before transition starts
        this.$transitions.onBefore({}, () => {
            this.$window.scrollTo(0, 0);
        });
    }

    // Navigate to next step
    nextStep() {
        const nextIndex = this.currentStep + 1;
        if (nextIndex < this.steps.length) {
            this.$state.go(`conversion-quiz.${this.steps[nextIndex].name}`);
        }
    }

    // Store answer and move to next step
    submitAnswer(questionKey, answer) {
        this.answers[questionKey] = answer;
        
        // Track answer
        analyticsService.trackEvent('Conversion Quiz', 'answer', questionKey, null, {
            answerValue: typeof answer === 'object' ? JSON.stringify(answer) : answer
        });
        this.nextStep();
    }

    // Get current progress percentage
    getProgress() {
        return (this.currentStep + 1) / this.steps.length * 100;
    }
}

export default {
    template: template(),
    controller: ConversionQuizController
};



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/conversion-quiz.cmpt.js